var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-editor"},[_c('tiptap-vuetify',{staticClass:"content-editor__editor",attrs:{"extensions":_vm.extensions},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }